export default __webpack_public_path__ + "static/media/Distribution of Attacks Among Wholesale & Retail.952d378e.PNG";